export default __webpack_public_path__ + "static/media/banner-strategic-plan.0a1bb0a7.png";